import React, { Component } from "react";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Colors } from "config/StyleConfig";
import withStyles from '@mui/styles/withStyles';

const buttonStyles = (theme) => ({
  customButtonStyle: {
    background: Colors.backgroundIconButton,
    "&:hover, &.Mui-focusVisible": { backgroundColor: Colors.backgroundIconButtonHover },
  },
});

class EditButton extends Component {
  render() {
    const beingEdited = this.props.isEditing;
    const { classes } = this.props;
    const buttonStyle = this.props.background ? classes.customButtonStyle : undefined;

    return (
      <div style={{ flex: 1, textAlign: "right" }}>
        {!beingEdited && (
          <IconButton
            className={buttonStyle}
            onClick={this.props.onEditButtonClicked}
            size="large">
            <EditIcon fontSize="default" />
          </IconButton>
        )}
        {beingEdited && (
          <div>
            <IconButton
              className={buttonStyle}
              style={{ marginRight: 5 }}
              onClick={this.props.onConfirmButtonClicked}
              size="large">
              <CheckIcon fontSize="default" />
            </IconButton>
            <IconButton
              className={buttonStyle}
              onClick={this.props.onCancelButtonClicked}
              size="large">
              <CloseIcon fontSize="default" />
            </IconButton>
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(buttonStyles)(EditButton);
